class t {
  constructor() {
    this.current = this.detect();
    this.currentId = 0;
  }

  set(e) {
    this.current !== e && (this.currentId = 0, this.current = e);
  }

  reset() {
    this.set(this.detect());
  }

  nextId() {
    return ++this.currentId;
  }

  get isServer() {
    return this.current === "server";
  }

  get isClient() {
    return this.current === "client";
  }

  detect() {
    return typeof window == "undefined" || typeof document == "undefined" ? "server" : "client";
  }

}

let n = new t();
export { n as env };